<script setup lang="ts">
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { FlowLayout } from '@Shared';
import useCompanyImageBaseUrl from '@Use/useCompanyImageBaseUrl';
import VerificationEndedImage from '@Assets/images/verification-ended.svg';

const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const companyImageBaseUrl = useCompanyImageBaseUrl();
</script>

<template>
    <flow-layout
        is-white-label
        suppress-back-to-dashboard
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        :show-progress="false"
    >
        <app-form-content-layout>
            <div class="verification-ended-view">
                <app-image :src="VerificationEndedImage" data-id="verification-ended-view-image" />
                <div class="verification-ended-view__inner-text-container">
                    <h1 data-id="verification-ended-view-title">This verification has ended</h1>
                    <p data-id="verification-ended-view-description">We've notified your closing team and they'll reach out to you.</p>
                </div>
                <p class="verification-ended-view__footer-text" data-id="verification-ended-view-footer-text">You may now close this tab.</p>
            </div>
        </app-form-content-layout>
    </flow-layout>
</template>

<style lang="scss" scoped>
.verification-ended-view {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__inner-text-container {
        margin-top: 0.5rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    &__footer-text {
        margin-top: 1.5rem;
    }
}
</style>
